import { render, staticRenderFns } from "./SubAreaNecessity.vue?vue&type=template&id=f823e19e&scoped=true"
import script from "./SubAreaNecessity.vue?vue&type=script&lang=js"
export * from "./SubAreaNecessity.vue?vue&type=script&lang=js"
import style0 from "./SubAreaNecessity.vue?vue&type=style&index=0&id=f823e19e&prod&lang=css"
import style1 from "./SubAreaNecessity.vue?vue&type=style&index=1&id=f823e19e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f823e19e",
  null
  
)

export default component.exports